<template lang="pug">
.toggle-row
  aiq-switch(:model-value="config.enable" @change="onEnabled"
      style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA")
  h3.title {{ $t('settings_tab.admin_tab.feedback_display_duration.title') }}
  aiq-tooltip(:content="$t('settings_tab.admin_tab.feedback_display_duration.tooltip')"
    placement="top")
    fa-icon.question-mark(:icon="['fas', 'circle-question']")

.form-field-container(v-if="config.enable")
  .form-field-label {{ $t('settings_tab.admin_tab.feedback_display_duration.duration') }}
  aiq-input.duration-input(v-model="config.display_days"
      :placeholder="$t('settings_tab.admin_tab.feedback_display_duration.duration_placeholder')"
      size="small"
      type="number"
      min="0"
      @keydown.enter="saveDuration()")
</template>

<script>
export default {
  name: 'feedback-display-duration',
  data() {
    return {
      config: {
        enable: false,
        display_days: 0,
      },
    };
  },
  async mounted() {
    this.config = await this.$store.dispatch('settings/getSetting', {
      name: 'feedback_display_duration',
    });
  },
  methods: {
    async onEnabled(value) {
      this.config.enable = value;
      await this.saveDuration();
    },
    async saveDuration() {
      try {
        this.config.display_days = parseInt(this.config.display_days);
        if (this.config.display_days < 0 || isNaN(this.config.display_days)) {
          this.$aiq.notify.info(this.$t('settings_tab.admin_tab.feedback_display_duration.invalid_days'));
          return;
        }
        await this.$store.dispatch('settings/updateSetting', {
          name: 'feedback_display_duration',
          payload: this.config,
        });
        this.$aiq.notify.success(this.$t('settings_tab.admin_tab.feedback_display_duration.success'));
      } catch (error) {
        this.$aiq.notify.error(this.$t('settings_tab.admin_tab.feedback_display_duration.error'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.form-field-container {
  margin-top: 16px;
  margin-bottom: 16px;
}
.form-field-label {
  font-weight: bold;
  margin-bottom: 8px;
}

.duration-input {
  width: 250px;
}
</style>
